import { FC } from "react";
import { IconButton } from "@mui/material";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import ImageIcon from "@mui/icons-material/Image";
import { AttachmentText } from "constants/text";
import {
	Comment,
	CommentAttachment,
	CommentAttachmentInfo,
	CommentCardContainer,
	CommentCardHeader
} from "./CustomQuoteCommentsFlyout.styles";
import { models } from "types/api/viewModels";
import useAttachments, { AttachmentWithUrl } from "hooks/useAttachments";
import { formatTimestamp, getCommentDisplayName } from "components/CustomQuote/customQuoteUtils";

interface CommentCardProps {
	comment: models["CustomQuoteCommentViewModel"];
	quote: models["CustomQuoteViewModel"] | undefined;
}

const CommentCard: FC<CommentCardProps> = ({ comment, quote }) => {
	const { attachmentsWithUrls } = useAttachments({
		attachmentUrls: comment.attachmentUrls ?? [],
		containerId: quote?.quoteId ?? ""
	});

	return (
		<CommentCardContainer>
			<CommentCardHeader>
				<span>{formatTimestamp(comment.timestamp)}</span>
			</CommentCardHeader>
			<Comment>
				<span data-testid="comment-display-name">{getCommentDisplayName(quote, comment)}:</span>{" "}
				{comment.comment}
			</Comment>
			{attachmentsWithUrls.map((attachment: AttachmentWithUrl, idx: number) => {
				const FileIcon = attachment.isPdf ? PictureAsPdfIcon : ImageIcon;
				return (
					<CommentAttachment key={attachment.url}>
						<div>
							<FileIcon fontSize="large" />
							<CommentAttachmentInfo>
								<p>{attachment.fileName ? attachment.fileName : AttachmentText}</p>
							</CommentAttachmentInfo>
						</div>
						<IconButton
							role="button"
							LinkComponent="a"
							href={attachment.blobUrl || "#"}
							download={attachment.blobUrl ? attachment.fileName : undefined}
							disabled={!attachment.blobUrl}
							target="_blank"
							data-testid={`comment-attachment-download-button-${idx}`}
						>
							<FileDownloadIcon
								className="download-icon"
								fontSize="small"
							/>
						</IconButton>
					</CommentAttachment>
				);
			})}
		</CommentCardContainer>
	);
};

export default CommentCard;
